import React, { useState, useEffect } from "react";
import { MdNightsStay, MdWbSunny } from "react-icons/md";

const Header = ({ darkMode, setDarkMode }) => {
  const [navState, setNavState] = useState(false);

  const onScroll = () => {
    if (window.scrollY > 30) {
      setNavState(true);
    } else {
      setNavState(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
  return (
    <header
      className={
        !navState
          ? `dark:bg-gray-900 dark:text-white absolute top-0 left-0 right-0 opacity-100 z-50`
          : "bg-white dark:bg-gray-900 dark:text-white opacity-100 z-[100] fixed top-0 left-0 right-0 blur-effect-theme"
      }
    >
      <nav className="flex justify-between items-center p-5">
        <h1 className="text-13xl animate-pulse">ANUP</h1>
        <div onClick={() => setDarkMode((prev) => !prev)}>
          {darkMode ? (
            <MdNightsStay className="text-2xl cursor-pointer" />
          ) : (
            <MdWbSunny className="text-2xl cursor-pointer color-white" />
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
